import { useTypedQuery } from "hooks";
import { DevicesDashboardQueryKeys } from "modules/DevicesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";

const formatBrands = (brands: string[]): DropdownItemProps<string>[] => brands.map(b => ({ key: b, value: b, text: b }));

export const useBrandsQuery = () =>
  useTypedQuery({
    queryKey: DevicesDashboardQueryKeys.brands,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.brands,
    select: formatBrands
  });
